module.exports = __webpack_public_path__ + "img/width-wide.c8fd2fe.webp";